import { JaneJohnTask } from '@/api/janeJohn';
import { ProjectType } from '@/api/project';
import { scheduleToString } from '@/utils/format';

type PreviewDetailProps = {
  description: string;
  tags: string[];
  projectType: ProjectType;
  isSecondaryUse?: boolean;
  creatorImage?: string;
  contractPeriodFrom?: string | null;
  contractPeriodTo?: string | null;
  applicationConditions?: string[];
  task?: JaneJohnTask;
};

export const PreviewDetail = (props: PreviewDetailProps) => {
  return (
    <div className=" px-4 text-gray-700">
      <h4 className="mb-4 text-lg font-semibold leading-7 ">案件概要</h4>
      {props.applicationConditions !== undefined && (
        <div className="py-2 text-sm">
          <h5 className="mb-1 font-semibold leading-5 ">応募条件</h5>
          <div className="flex flex-wrap gap-2">
            {props.applicationConditions.map((value) => {
              return (
                <div className="whitespace-nowrap rounded-sm bg-[#F3F4F6] text-xs" key={value}>
                  {value}
                </div>
              );
            })}
          </div>
        </div>
      )}
      <div className="py-2 text-sm">
        <h5 className="mb-1 font-semibold leading-5 ">歓迎条件</h5>
        <div>
          {props.tags
            .filter((tag) => tag !== '-')
            .map((tag, index) => (
              <span key={index} className="mb-2 mr-2 inline-block rounded-sm bg-[#F3F4F6] px-2 pb-1 pt-[2px] text-xs">
                {tag}
              </span>
            ))}
        </div>
      </div>
      <div className="py-2 text-sm">
        <h5 className="mb-1 font-semibold leading-5">案件説明</h5>
        <p>{props.description}</p>
      </div>
      {props.isSecondaryUse !== undefined && (
        <div className="py-2 text-sm">
          <h5 className="mb-1 font-semibold leading-5">企業の二次利用（リポスト）</h5>
          {props.isSecondaryUse ? (
            <div className="flex items-center gap-2">
              <p className="w-10">あり</p>
              <p className="text-xs">&#42;報酬は二次利用費を含んだ金額です</p>
            </div>
          ) : (
            <div className="flex items-center gap-2">
              <p className="w-10">なし</p>
            </div>
          )}
        </div>
      )}
      {props.creatorImage !== undefined && (
        <div className="py-2 text-sm">
          <h5 className="mb-1 font-semibold leading-5">募集クリエイターイメージ</h5>
          <p>{props.creatorImage}</p>
        </div>
      )}
      {props.contractPeriodFrom !== undefined && props.contractPeriodTo !== undefined && (
        <div className="py-2 text-sm">
          <h5 className="mb-1 font-semibold leading-5">契約期間</h5>
          <p>{scheduleToString(props.contractPeriodFrom, props.contractPeriodTo)}</p>
        </div>
      )}
      {props.task !== undefined && (
        <>
          {props.task.type === 'group_interview' && (
            <div className="py-2 text-sm">
              <h5 className="mb-1 font-semibold leading-5">グループインタビュー</h5>
              <p>
                インタビュー実施日：
                {props.task.groupInterView && props.task.groupInterView.interviewDate
                  ? props.task.groupInterView.interviewDate.replaceAll('-', '/')
                  : ''}
              </p>
            </div>
          )}
          {props.task.type === 'spot_consul' && (
            <div className="py-2 text-sm">
              <h5 className="mb-1 font-semibold leading-5">スポットコンサル</h5>
              <p>
                実施期間：
                {props.task.spotConsul
                  ? scheduleToString(props.task.spotConsul.startedAt, props.task.spotConsul.endedAt)
                  : ''}
              </p>
            </div>
          )}
          {props.task.type === 'questionnaire' && (
            <div className="py-2 text-sm">
              <h5 className="mb-1 font-semibold leading-5">アンケート</h5>
              <p>
                アンケート実施日：
                {props.task.question && props.task.question.interviewDate
                  ? props.task.question.interviewDate.replaceAll('-', '/')
                  : ''}
              </p>
              <p>
                アンケート設問数：
                {props.task.question && props.task.question.questionNum
                  ? `～${props.task.question.questionNum.replace('to_', '')}問`
                  : ''}
              </p>
            </div>
          )}
        </>
      )}
      <div className="mb-[25px] mt-[18px] h-[1px] w-[273px] bg-gray-300" />
    </div>
  );
};
